/* Bound cart requests, never replay a write whose result is unknown. */
(function () {
  'use strict';
  if (window.WD_CART_SAFETY) return;
  var nativeFetch = window.fetch.bind(window), reviewRequired = false;
  var message = '通信が途切れました。カートの内容を確認してからお進みください。';
  function recovery(host) {
    if (!host || host.querySelector('[data-wd-cart-recovery]')) return;
    var link = document.createElement('a');
    link.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
    link.setAttribute('data-wd-cart-recovery', '');
    link.textContent = 'カートを確認して購入手続きへ';
    link.style.cssText = 'display:block;text-decoration:underline;padding:12px 0';
    host.appendChild(link);
  }
  function failure() { var error = new Error(message); error.wdCartUncertain = reviewRequired; return error; }
  window.WD_CART_SAFETY = { recovery: recovery };
  window.fetch = function (input, options) {
    var url;
    try { url = new URL(typeof input === 'string' || input instanceof URL ? String(input) : input.url, location.href); }
    catch (_) { return nativeFetch(input, options); }
    var cart = url.origin === location.origin && (/\/cart(?:\/(?:add|change|update|clear))?\.js$/.test(url.pathname) || url.searchParams.has('sections'));
    if (!cart) return nativeFetch(input, options);
    var method = String(options && options.method || input && input.method || 'GET').toUpperCase();
    var write = method === 'POST' && /\/cart\/(?:add|change|update|clear)(?:\.js)?$/.test(url.pathname);
    if (write && reviewRequired) return Promise.reject(failure());
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var upstream = options && options.signal || input && input.signal;
    var abort = function () { if (controller) controller.abort(); };
    if (controller && upstream) {
      if (upstream.aborted) controller.abort();
      else upstream.addEventListener('abort', abort, { once: true });
    }
    var opts = Object.assign({}, options);
    if (controller) opts.signal = controller.signal;
    var timer;
    var deadline = new Promise(function (_, reject) {
      timer = setTimeout(function () { if (write) reviewRequired = true; abort(); reject(failure()); }, 15000);
    });
    // Include body transfer in the deadline, not just response headers.
    var request = nativeFetch(input, opts).then(function (response) {
      if (write && response.status >= 500) reviewRequired = true;
      return response.arrayBuffer().then(function (body) {
        var headers = new Headers(response.headers);
        headers.delete('content-length'); headers.delete('content-encoding');
        return new Response(response.status === 204 ? null : body, { status: response.status, statusText: response.statusText, headers: headers });
      });
    });
    return Promise.race([request, deadline]).catch(function () {
      if (write) reviewRequired = true;
      throw failure();
    }).finally(function () {
      clearTimeout(timer);
      if (upstream && controller) upstream.removeEventListener('abort', abort);
    });
  };
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && (reviewRequired || document.querySelector('cart-drawer.wd-cart-pending,cart-drawer.wd-cart-updating'))) location.reload();
  });
})();
